import { useState, useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";

import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";

import { AccountContext } from "context/account";
import PulseLoader from "react-spinners/PulseLoader";

import ProjectMaHome from "pages/ma/project";
import ProjectDeHome from "pages/de/project";

const ProjectHomeIndex = ({ stage }) => {
  const { account_type } = useContext(AccountContext);
  if (!account_type) {
    return (
      <SuiBox display="flex" alignItems="center" gap={3}>
        <PulseLoader />
        <SuiTypography variant="h6" fontWeight="medium">
          Loading...
        </SuiTypography>
      </SuiBox>
    );
  }

  return account_type == "de" ? <ProjectDeHome stage={stage} /> : <ProjectMaHome stage={stage} />;
};

export default ProjectHomeIndex;
